<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";

import type { User } from "~/shared/types";
import { usePageStore } from "~/stores";
import { getUserPageLink } from "~/utils/common";
import { isInaccessibleAgent } from "~/utils/user";

const props = defineProps<{
  user?: User;
  title?: string;
  noUnderline?: boolean;
}>();

const router = useRouter();
const pageStore = usePageStore();

const link = computed(() =>
  props.user && !pageStore.isPublicView && !isInaccessibleAgent(props.user)
    ? getUserPageLink(props.user, router.currentRoute.value)
    : undefined
);
</script>

<template>
  <RouterLink
    v-if="user && link"
    :to="link"
    :title="title"
    class="cursor-pointer rounded-sm focus-ring-std"
    :class="!noUnderline && 'hover:underline'"
    @click.stop>
    <slot />
  </RouterLink>
  <span v-else :title="title">
    <slot />
  </span>
</template>
